import { c as _c } from "react/compiler-runtime";
import type { GetProps } from 'antd';
import { Input } from 'antd';
import './classes.css';
type OTPProps = GetProps<typeof Input.OTP>;
interface OTPInputProps extends OTPProps {
  wrapperClassName?: string;
  errorMessage?: string;
}
export const OTPInput = t0 => {
  const $ = _c(14);
  let errorMessage;
  let props;
  let status;
  let wrapperClassName;
  if ($[0] !== t0) {
    ({
      wrapperClassName,
      errorMessage,
      status,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = errorMessage;
    $[2] = props;
    $[3] = status;
    $[4] = wrapperClassName;
  } else {
    errorMessage = $[1];
    props = $[2];
    status = $[3];
    wrapperClassName = $[4];
  }
  const t1 = `my_seven_otp flex w-full flex-col items-center gap-2 ${wrapperClassName} ${errorMessage ? "code_error" : ""}`;
  const t2 = errorMessage ? "error" : status;
  let t3;
  if ($[5] !== props || $[6] !== t2) {
    t3 = <Input.OTP length={5} status={t2} size="large" {...props} />;
    $[5] = props;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== errorMessage) {
    t4 = errorMessage && <span className="self-start text-[14px] text-base text-[#ED3F3F]">{errorMessage}</span>;
    $[8] = errorMessage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className={t1}>{t3}{t4}</div>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};